var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 7.20005C6.66275 7.20005 7.20001 6.66279 7.20001 6.00005C7.20001 5.33731 6.66275 4.80005 6.00001 4.80005C5.33726 4.80005 4.80001 5.33731 4.80001 6.00005C4.80001 6.66279 5.33726 7.20005 6.00001 7.20005Z",
    fill: "#8F959F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.274658 6.00007C1.03921 3.5658 3.31339 1.80005 5.99998 1.80005C8.68656 1.80005 10.9607 3.56578 11.7253 6.00003C10.9607 8.4343 8.68656 10.2 5.99997 10.2C3.31339 10.2 1.03922 8.43432 0.274658 6.00007ZM8.40001 6.00005C8.40001 7.32553 7.32549 8.40005 6.00001 8.40005C4.67452 8.40005 3.60001 7.32553 3.60001 6.00005C3.60001 4.67457 4.67452 3.60005 6.00001 3.60005C7.32549 3.60005 8.40001 4.67457 8.40001 6.00005Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b0d0d8690c57c5f6a2eec3bf6ca99232.svg";
export { ForwardRef as ReactComponent };